function game_302()
{

}

game_302.odd_map  = {
  "8":[0,0,200,400,800],
  "7":[0,0,100,200,400],
  "6":[0,0,50,100,200],
  "5":[0,0,20,50,150],
  "4":[0,0,20,50,100],
  "3":[0,0,10,20,60],
  "2":[0,0,5,10,30],
  "1":[0,0,5,10,20],
};

export {
  game_302
};



// WEBPACK FOOTER //
// ./src/components/slots/game_302.js